import {
  WorkOrderAuditDataComplementItemsSituationType,
  WorkOrderAuditDataComplementsSituationType,
  WorkOrderAuditDataSaleSituationType,
  WorkOrderAuditSituationType,
} from './AuditData.enums';

export const workOrderAuditSituationLabels = {
  [WorkOrderAuditSituationType.ClosedWithoutFinancial]:
    'OS fechada sem financeiro',
  [WorkOrderAuditSituationType.ClosedWithLiquidValueDifferentFromFinancial]:
    'OS fechada com valor líquido diferente do financeiro',
  [WorkOrderAuditSituationType.ClosedWithoutCommission]:
    'OS fechada sem comissão',
  [WorkOrderAuditSituationType.ClosedWithCommissionGreaterThanService]:
    'OS fechada com comissão maior que o valor do serviço',
  [WorkOrderAuditSituationType.ItemsWithSalePriceLowerThanCost]:
    'Item OS/Venda direta com valor de venda menor que o de custo',
  [WorkOrderAuditSituationType.ItemsWithZeroSaleOrUnitCost]:
    'Itens OS/Venda direta com valor de venda ou custo zerado',
};

export const AuditDataComplementsSituationTypeMapping: Partial<
  Record<
    WorkOrderAuditSituationType,
    WorkOrderAuditDataComplementsSituationType
  >
> = {
  [WorkOrderAuditSituationType.ClosedWithoutFinancial]:
    WorkOrderAuditDataComplementsSituationType.ClosedWithoutFinancial,
  [WorkOrderAuditSituationType.ClosedWithLiquidValueDifferentFromFinancial]:
    WorkOrderAuditDataComplementsSituationType.ClosedWithLiquidValueDifferentFromFinancial,
  [WorkOrderAuditSituationType.ClosedWithoutCommission]:
    WorkOrderAuditDataComplementsSituationType.ClosedWithoutCommission,
  [WorkOrderAuditSituationType.ClosedWithCommissionGreaterThanService]:
    WorkOrderAuditDataComplementsSituationType.ClosedWithCommissionGreaterThanService,
};

export const AuditDataSalesSituationTypeMapping: Partial<
  Record<WorkOrderAuditSituationType, WorkOrderAuditDataSaleSituationType>
> = {
  [WorkOrderAuditSituationType.ItemsWithSalePriceLowerThanCost]:
    WorkOrderAuditDataSaleSituationType.SalesWithSalePriceLowerThanCost,
  [WorkOrderAuditSituationType.ItemsWithZeroSaleOrUnitCost]:
    WorkOrderAuditDataSaleSituationType.SalesWithZeroRealPriceOrUnitCost,
};

export const AuditDataComplementItemsSituationTypeMapping: Partial<
  Record<
    WorkOrderAuditSituationType,
    WorkOrderAuditDataComplementItemsSituationType
  >
> = {
  [WorkOrderAuditSituationType.ItemsWithSalePriceLowerThanCost]:
    WorkOrderAuditDataComplementItemsSituationType.ItemsWithSalePriceLowerThanCost,
  [WorkOrderAuditSituationType.ItemsWithZeroSaleOrUnitCost]:
    WorkOrderAuditDataComplementItemsSituationType.ItemsWithZeroSaleOrUnitCost,
};
